// extracted by mini-css-extract-plugin
module.exports = {"button":"PlayButton_button__3G1Ca"};